import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'
import collectionsStore from '../collectionsStore'
import { StoreExt } from '@utils/reactExt'

import { termCollections, policyCollections } from '@services/api'

export class termCollectionsStore extends StoreExt {
    @observable loading = false
    @observable list = []
    @observable edit = {}

    @action
    updateList = async params => {
        this.loading = true
        const { list } = (await termCollections.getList({ ...params })).data
        collectionsStore.getCollection(
            window.location.href.slice(window.location.href.split('/', 4).join('/').length + 1)
        )
        runInAction(() => {
            this.list = list
            this.loading = false
        })
    }

    @action
    update = async () => {
        this.loading = true
        await termCollections.updateTermCollection({ ...this.edit })
        this.updateList({ collection_id: this.edit['collection_id'], term_id: this.edit['term_id'] })
        this.resetEdit()
    }

    @action
    submit = async () => {
        this.loading = true
        await termCollections.addTermCollection({ ...this.edit })
        await policyCollections.addCollection({ ...this.edit })
        this.updateList({ collection_id: this.edit['collection_id'], term_id: this.edit['term_id'] })
    }

    @action
    delete = async termCollection => {
        const { collection_id, term_id } = termCollection
        this.loading = true
        await termCollections.deleteTermCollection({ id: termCollection.id })
        await policyCollections.deleteCollection({
            policy_id: termCollection.policy_id,
            collection_id: termCollection.collection_id,
            fromTerms: true
        })
        this.updateList({ collection_id, term_id })
    }

    @action
    changeValue = async (name, value) => {
        this.edit[name] = value
    }

    @action
    toggleEdit = termCollection => {
        this.edit = { ...termCollection }
    }

    @action
    resetEdit = () => {
        this.edit = {}
    }

    @action
    resetList = () => {
        this.list = []
    }
}

export default remotedev(new termCollectionsStore())
